import { render, staticRenderFns } from "./RequestsTapSupervisor.vue?vue&type=template&id=8101b3c8&"
import script from "./RequestsTapSupervisor.vue?vue&type=script&lang=js&"
export * from "./RequestsTapSupervisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports